import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import PredictionDeviceTableDto from '../dto/PredictionDeviceTableDto';

class PredictionDeviceTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'predictionDeviceTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<PredictionDeviceTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, PredictionDeviceTableDto)))
				.catch(reject);
		});
	}
}

export default new PredictionDeviceTableService();
